// src/utils/catalogueOrder.js
//
// THE ordering rule for the four catalogue entities the cashier browses:
// dining options, categories, subcategories and products.
//
// Before this, the POS sorted all four alphabetically (five localeCompare
// calls in hooks/pos/useProductCatalog.js) and ignored the sort_order that
// Category, Subcategory and DiningOption have always had — so reordering
// categories in the portal changed nothing at the till. Product had no
// sort_order at all until migration 0078.
//
// sort_order first, name as the tie-break. The tie-break is not cosmetic: it
// keeps the menu stable while a tenant is part-way through arranging it, and
// during the window between the column being deployed and the back-fill
// running, when many rows still share sort_order 0.
//
// Imports NOTHING, so any surface can use it — same discipline as
// utils/transactionLines.js and utils/productPricing.js.

const order = (item) => {
    // `?? 0`, not `|| 0`: both null and undefined mean "unsorted", and an
    // unsorted row must sit at the FRONT with the other zeroes rather than
    // being pushed past everything by a NaN or an Infinity default.
    const value = Number(item?.sort_order ?? 0);
    return Number.isFinite(value) ? value : 0;
};

const name = (item) => String(item?.name ?? '');

export const byCatalogueOrder = (a, b) => {
    const delta = order(a) - order(b);
    if (delta !== 0) return delta;
    return name(a).localeCompare(name(b));
};

// Non-mutating: callers routinely sort arrays held in React state, and sorting
// those in place is a silent way to skip a re-render.
export const sortByCatalogueOrder = (items) =>
    (Array.isArray(items) ? [...items] : []).sort(byCatalogueOrder);

export default sortByCatalogueOrder;
